import { useState } from "react";
import { ChevronDown, Minus, Plus } from "lucide-react";
import { itemKey } from "@/data/collections";

const line = "var(--pp-border)";
const muted = "var(--pp-text-muted)";

export const AddOnItem = ({ item, addons, onChange }) => {
  const [open, setOpen] = useState(false);
  if (!item.variants) {
    return (
      <li className="py-2.5 flex items-center gap-4" style={{ borderColor: line }} data-testid={`addon-${item.id}`}>
        <div className="flex-1 min-w-0 text-sm" style={{ color: "var(--pp-text)" }}>{item.label}</div>
        <Counter value={addons[item.id] || 0} onChange={(v) => onChange(item.id, v)} testId={`item-${item.id}`} />
      </li>
    );
  }
  const total = item.variants.reduce((n, v) => n + (addons[itemKey(item, v)] || 0), 0);
  const sections = [...new Set(item.variants.map((v) => v.section || ""))];
  return (
    <li className="py-2.5" style={{ borderColor: line }} data-testid={`addon-${item.id}`}>
      <button type="button" data-testid={`addon-toggle-${item.id}`} onClick={() => setOpen((o) => !o)} aria-expanded={open} className="w-full flex items-center gap-4 text-left">
        <div className="flex-1 min-w-0 text-sm" style={{ color: "var(--pp-text)" }}>{item.label}</div>
        <span className="text-xs" style={{ color: total ? "var(--pp-burgundy)" : muted }} data-testid={`addon-count-${item.id}`}>{total ? `${total} added` : "Choose"}</span>
        <ChevronDown className="h-4 w-4 shrink-0 transition-transform" style={{ color: "var(--pp-terracotta)", transform: open ? "rotate(180deg)" : "none" }} />
      </button>
      {open && (
        <div className="mt-2 ml-3 pl-3 border-l space-y-3" style={{ borderColor: line }} data-testid={`addon-variants-${item.id}`}>
          {sections.map((sec) => (
            <div key={sec}>
              {sec && <div className="pp-caption mb-1 mt-1">{sec}</div>}
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6">
                {item.variants.filter((v) => (v.section || "") === sec).map((v) => {
                  const key = itemKey(item, v);
                  return (
                    <li key={key} className="py-1.5 flex items-center gap-3">
                      <div className="flex-1 min-w-0 text-sm" style={{ color: muted }}>{v.label}</div>
                      <Counter value={addons[key] || 0} onChange={(n) => onChange(key, n)} testId={`item-${key.replace(/:/g, "-")}`} small />
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      )}
    </li>
  );
};

export function Counter({ value, onChange, testId, small }) {
  const sz = small ? "h-8 w-8" : "h-9 w-9";
  return (
    <div className="inline-flex items-center" style={{ border: `1px solid ${line}` }}>
      <button type="button" data-testid={`${testId}-decrease`} aria-label="Decrease" onClick={() => onChange(value - 1)} disabled={value <= 0} className={`${sz} inline-flex items-center justify-center disabled:opacity-30`} style={{ color: "var(--pp-burgundy)" }}><Minus className="h-4 w-4" /></button>
      <input type="number" min="0" step="1" value={value} data-testid={`${testId}-input`} onChange={(e) => onChange(parseInt(e.target.value, 10) || 0)} className="w-10 text-center bg-transparent focus:outline-none text-sm font-medium" style={{ color: "var(--pp-burgundy)" }} />
      <button type="button" data-testid={`${testId}-increase`} aria-label="Increase" onClick={() => onChange(value + 1)} className={`${sz} inline-flex items-center justify-center`} style={{ color: "var(--pp-burgundy)" }}><Plus className="h-4 w-4" /></button>
    </div>
  );
}
